var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1171275923(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 41,
    fill: "#FF947A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6006 28.7C24.6006 24.1713 28.2719 20.5 32.8006 20.5H45.1006V28.7C45.1006 33.2287 48.7719 36.9 53.3006 36.9H57.4006V53.3C57.4006 57.8287 53.7293 61.5 49.2006 61.5H32.8006C28.2719 61.5 24.6006 57.8287 24.6006 53.3V28.7ZM32.8006 38.95C31.6684 38.95 30.7506 39.8678 30.7506 41C30.7506 42.1322 31.6684 43.05 32.8006 43.05H36.9006C38.0328 43.05 38.9506 42.1322 38.9506 41C38.9506 39.8678 38.0328 38.95 36.9006 38.95H32.8006ZM32.8006 47.15C31.6684 47.15 30.7506 48.0678 30.7506 49.2C30.7506 50.3322 31.6684 51.25 32.8006 51.25H41.0006C42.1328 51.25 43.0506 50.3322 43.0506 49.2C43.0506 48.0678 42.1328 47.15 41.0006 47.15H32.8006ZM50.5983 25.0075L50.3298 29.0339C50.2473 30.2715 51.2741 31.2982 52.5117 31.2157L56.538 30.9473C58.2954 30.8301 59.0967 28.6977 57.8512 27.4523L54.0933 23.6943C52.8479 22.4489 50.7154 23.2501 50.5983 25.0075Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6006 28.7C24.6006 24.1713 28.2719 20.5 32.8006 20.5H45.1006V28.7C45.1006 33.2287 48.7719 36.9 53.3006 36.9H57.4006V53.3C57.4006 57.8287 53.7293 61.5 49.2006 61.5H32.8006C28.2719 61.5 24.6006 57.8287 24.6006 53.3V28.7ZM32.8006 38.95C31.6684 38.95 30.7506 39.8678 30.7506 41C30.7506 42.1322 31.6684 43.05 32.8006 43.05H36.9006C38.0328 43.05 38.9506 42.1322 38.9506 41C38.9506 39.8678 38.0328 38.95 36.9006 38.95H32.8006ZM32.8006 47.15C31.6684 47.15 30.7506 48.0678 30.7506 49.2C30.7506 50.3322 31.6684 51.25 32.8006 51.25H41.0006C42.1328 51.25 43.0506 50.3322 43.0506 49.2C43.0506 48.0678 42.1328 47.15 41.0006 47.15H32.8006ZM50.5983 25.0075L50.3298 29.0339C50.2473 30.2715 51.2741 31.2982 52.5117 31.2157L56.538 30.9473C58.2954 30.8301 59.0967 28.6977 57.8512 27.4523L54.0933 23.6943C52.8479 22.4489 50.7154 23.2501 50.5983 25.0075Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1171275923);
export default __webpack_public_path__ + "static/media/Group 1171275923.adaf10a7e10a95bd4b79e9d4c87226c8.svg";
export { ForwardRef as ReactComponent };